export default __webpack_public_path__ + "static/media/404.6862c3b5.png";